import { getOverlappingDaysInRanges, isAfter } from 'date-fns';
import { SetSchedule, DateString, ScheduleResult } from './types';

const overlappingDaysInRanges = (
  schedule: SetSchedule,
  date_start: DateString,
) =>
  schedule.filter(({ period_from, period_to }) => {
    if (isAfter(period_to, date_start) && isAfter(period_to, period_from)) {
      return getOverlappingDaysInRanges(
        date_start,
        period_to,
        period_from,
        period_to,
      );
    }
    return false;
  });
const setSchedule = (
  schedule: SetSchedule,
  date_start = new Date(),
): ScheduleResult => {
  const week = ['пн', 'вт', 'ср', 'чт', 'пт', 'сб', 'вс'];
  const currentSchedule = overlappingDaysInRanges(schedule, date_start);

  if (!currentSchedule.length) return [];
  return week.map((day, index) => {
    const time = currentSchedule.reduce(
      (result: Array<string>, { week_days, time_start, time_end }) => {
        const indicator = index + 1;
        if (week_days.includes(indicator !== 7 ? indicator : 0)) {
          result.push(time_end ? `${time_start} — ${time_end}` : time_start);
        }
        return result;
      },
      [],
    );

    return { day, time };
  });
};

export default setSchedule;



// WEBPACK FOOTER //
// ./src/services/api/event-groups/utils/setSchedule.ts